module.exports = __webpack_public_path__ + "img/mysize.d8bdc323.png";